import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Autenticacao",
    component: () => import("@/views/Autenticacao.vue"),
  },
  {
    path: "/listaConfiguracoes",
    name: "ListaConfiguracoes",
    component: () => import("@/views/ListaConfiguracoes.vue"),
  },
  {
    path: "/configuracoes/:id",
    name: "Configuracoes",
    props: true,
    component: () => import("@/views/Configuracoes.vue"),
  },
  {
    path: "/configuracoes",
    name: "Configuracoes",
    component: () => import("@/views/Configuracoes.vue"),
  },
  {
    path: "/passos",
    name: "Passos",
    component: () => import("@/views/PassosHorario.vue"),
    props: true,
  },
  {
    path: "/quantidades/:id",
    name: "Quantidades",
    props: true,
    component: () => import("@/views/Quantidades.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name !== "Autenticacao" && store.state.authToken == null) {
    next({ name: "Autenticacao" });
  }
  next();
});

export default router;
